import { axios } from "utils";

import { ADMIN_CARBON_PROGRAM_DRAFTS_URL } from "consts";

import {
  CarbonProgramDraftDetails,
  CarbonProgramDraftStatus,
  CarbonProgramDraftSummary,
  CreateCarbonProgramDraftRequest,
  ReviewCarbonProgramDraftRequest,
  UpdateCarbonProgramDraftRequest,
} from "models";

export const getCarbonProgramDrafts = async (params: { status?: CarbonProgramDraftStatus; programId?: string } = {}): Promise<CarbonProgramDraftSummary[]> =>
  axios.get(ADMIN_CARBON_PROGRAM_DRAFTS_URL, { params });

export const getCarbonProgramDraft = async (id: string): Promise<CarbonProgramDraftDetails> => axios.get(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}`);

export const createCarbonProgramDraft = async (data: CreateCarbonProgramDraftRequest): Promise<CarbonProgramDraftDetails> =>
  axios.post(ADMIN_CARBON_PROGRAM_DRAFTS_URL, { data });

export const updateCarbonProgramDraft = async ({ id, ...data }: UpdateCarbonProgramDraftRequest): Promise<CarbonProgramDraftDetails> =>
  axios.put(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}`, { data });

export const deleteCarbonProgramDraft = async (id: string): Promise<void> => axios.delete(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}`);

export const submitCarbonProgramDraft = async (id: string): Promise<CarbonProgramDraftDetails> => axios.post(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}/submit`);

export const reviewCarbonProgramDraft = async ({ id, ...data }: ReviewCarbonProgramDraftRequest): Promise<CarbonProgramDraftDetails> =>
  axios.post(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}/review`, { data });

export const markCarbonProgramDraftImplemented = async (id: string): Promise<CarbonProgramDraftDetails> =>
  axios.post(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}/implemented`);

const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new DOMException("Problem parsing input file."));
    reader.readAsDataURL(file);
  });

export const uploadCarbonProgramDraftContract = async ({ id, file }: { id: string; file: File }): Promise<CarbonProgramDraftDetails> =>
  axios.post(`${ADMIN_CARBON_PROGRAM_DRAFTS_URL}/${id}/contract`, { data: { file: await readFileAsDataUrl(file) } });
